'use client';

import { Dialog, DialogContent, Grid, Typography, DialogActions } from '@mui/material';
import { useTranslations } from 'use-intl';

import { Button } from '../../../../../../components/button/Button';

import type { ILeaveFormAlertDialogProps } from './leaveFormAlertDialog.type';

export const LeaveFormAlertDialog = ({ handleClose, handleAccept }: ILeaveFormAlertDialogProps) => {
  const t = useTranslations();

  return (
    <Dialog open maxWidth="sm">
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography variant="h6">{t('headers.leaveFormAlert')}</Typography>
          </Grid>
          <Grid size={12}>
            <Typography>{t('text.leaveFormAlert')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button handleClick={handleClose}>{t('labels.cancel')}</Button>
        <Button variant="contained" handleClick={handleAccept}>
          {t('labels.goForward')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
